import styled from '@emotion/styled';
import { Color, mediaQueries } from 'styles/variables';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    ${mediaQueries.largeUp} {
        flex-direction: row;
    }

    .checkBoxWrapper {
        ${mediaQueries.mediumUp} {
            max-width: 65%;
        }
    }
    .termsList {
        list-style-position: initial;
        margin-left: 2rem;
    }
    .help-block {
        margin-bottom: 0;
    }
`;
export const FormContainer = styled.div`
    flex-grow: 1;
    margin-bottom: 2.5rem;
    ${mediaQueries.largeUp} {
        border-right: 1px solid ${Color.storm11};
        margin-right: 1.2rem;
        padding-right: 5rem;
        margin-bottom: 0;
    }
    h2 {
        margin-bottom: 1.5rem;
    }
    .columns {
        margin-bottom: 1.5rem;
    }
`;
